import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import googleCalendarPlugin from "@fullcalendar/google-calendar";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Wrapper from "../Helpers/Wrapper";
import Modal from "react-bootstrap/Modal";
import { monthNames, days } from '../config/Globals';
import "./McmtaCalendar.css";

const McmtaCalendar = () => {
  const [showModal, setShow] = useState(false);
  const [eventDetails, setEventDetails] = useState({});

  const showModalHandler = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const handleEventClick = (info) => {
    // console.log(JSON.stringify(info));
    // console.log(JSON.stringify(info.el));
    // console.log(JSON.stringify(info.jsEvent));
    // console.log(JSON.stringify(info.view));
    // console.log(JSON.stringify(info.event));
    info.jsEvent.preventDefault();
    // setEventDetails(info.event.title)
    setEventDetails({
      title: info.event.title,
      startDate: info.event.start,
      endDate: info.event.end,
      location: info.event.extendedProps.location
        ? info.event.extendedProps.location
        : null,
      description: info.event.extendedProps
        ? info.event.extendedProps.description
        : null,
    });
    showModalHandler();
  };

  const convertDate = (dateToConvert) => {
 
    const monthInDate = monthNames[dateToConvert.getMonth()];
    const dayInDate = dateToConvert.getDate();
    const yearInDate = dateToConvert.getFullYear();
    const dayNameInDate = days[dateToConvert.getDay()];
    return `${dayNameInDate} ${monthInDate} ${dayInDate}, ${yearInDate}`;
  };

  const buttonText = {
    month: "Monthly View",
    list: "List Events",
    today: "Current Month",
    next: "Next Month",
    prev: "Previous Month",
  } 

  return (
    <Wrapper>
      <FullCalendar
        height="75vh"
        handleWindowResize={true}
        plugins={[
          googleCalendarPlugin,
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          listPlugin,
          bootstrap5Plugin,
        ]}
        buttonText={buttonText}
        googleCalendarApiKey="AIzaSyBOFUwSbPOEvD4dFD_V7zfvVIKQAxsT0x4"
        events={{ googleCalendarId: "mcmta.md@gmail.com" }}
        // initialView="dayGridMonth"
        initialView="listMonth"
        weekends={true}
        eventClick={handleEventClick}
        // select={handleDateClick}
        themeSystem={"bootstrap5"}
        // headerToolbar={{
        //   start: "today prev,next",
        //   center: "title",
        //   end: "dayGridMonth,listMonth",
        //   // end: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
        // }}
        headerToolbar={{
          start: "today",
          center: "title",
          end: "prev next",
        }}
      />
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{eventDetails.title && eventDetails.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {eventDetails.description && (
            <>
              <Row >
                <Col>
                  <strong>Event Details:</strong>
                </Col>
              </Row>
              <Row className="text-center">
                <Col>{eventDetails.description}</Col>
              </Row>
            </>
          )}
          {eventDetails.startDate && (
            <>
              <Row >
                <strong>Event Start Date:</strong>
              </Row>
              <Row className="text-center">
                <Col>{convertDate(eventDetails.startDate)}</Col>
              </Row>
            </>
          )}
          {eventDetails.endDate && (
            <>
              <Row >
                <strong>Event End Date:</strong>
              </Row>
              <Row className="text-center">
                <Col>{convertDate(eventDetails.endDate)}</Col>
              </Row>
            </>
          )}
          {eventDetails.location && (
            <>
              <Row >
                <strong>Event Location:</strong>
              </Row>
              <Row className="text-center">
                <Col>{eventDetails.location}</Col>
              </Row>
            </>
          )}
        </Modal.Body>
      </Modal>
    </Wrapper>
  );
};

export default McmtaCalendar;
